function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ServerErrorHero } from "common/widgets/warning-hero/presets";
import { WarningHeroReportName } from "common/widgets/warning-hero/constants";
import { UsersTableEl } from "common/widgets/users-table";
import { SpinnerEl } from "common/components/spinner";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonLayout, ButtonTheme } from "common/components/button/constants";
import { CreateCohortButtonEl } from "common/widgets/create-cohort-button";
import { pluralize } from "common/util/string";
import { currentProjectStore } from "common/report/stores/project-details";
import { Permission } from "common/report/constants";
import { TooltipEl } from "common/components/tooltip";
import { isGlobalSidenavEnabled } from "iron/routes/global-sidenav/utils";
import { TrackingEvent } from "../tracking";
export function template() {
  var _this$attr, _currentProjectStore$;
  const segments = this.attr("segments");
  const {
    loadingCount,
    totalUsers = 0,
    loading,
    users,
    error,
    cohort
  } = this.state;
  const dgContext = this.attr("data-group-name") === "user" ? "user" : void 0;
  const {
    t,
    print
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".wrapper", class: {
    "global-sidenav-enabled": isGlobalSidenavEnabled(this.getCurrentProject())
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".header" }, /* @__PURE__ */ jsx("h2", null, t("view-users.title", {
    context: dgContext,
    group: pluralize(this.attr("data-group-name"), true)
  }), ((_this$attr = this.attr("data-group-name")) === null || _this$attr === void 0 ? void 0 : _this$attr.length) > 25 && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: "View ".concat(pluralize(this.attr("data-group-name"), true))
  } })), /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".info" }, /* @__PURE__ */ jsx("h3", null, /* @__PURE__ */ jsx("span", { sel: ".color", style: {
    background: this.attr("color")
  } }), segments.join(" / ")), /* @__PURE__ */ jsx("p", null, !loadingCount ? totalUsers.toLocaleString() : /* @__PURE__ */ jsx(SpinnerEl, null), " ", this.params.createSegmentLabel ? print(this.params.createSegmentLabel({
    context: this.attr("data-group-name"),
    count: totalUsers,
    group: pluralize(this.attr("data-group-name"), totalUsers)
  })) : t("view-users.count-label", {
    context: dgContext,
    count: totalUsers,
    group: pluralize(this.attr("data-group-name"), totalUsers)
  })), /* @__PURE__ */ jsx("div", { sel: ".actions" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    icon: "export-csv",
    layout: ButtonLayout.Vertical
  }, on: {
    click: this.handleDownloadCsv
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, t("view-users.export-csv")), ((_currentProjectStore$ = currentProjectStore.value) === null || _currentProjectStore$ === void 0 ? void 0 : _currentProjectStore$.hasPermission(Permission.WriteCohorts)) && !this.attr("hide-cohort-functionality") && /* @__PURE__ */ jsx(CreateCohortButtonEl, { attrs: {
    label: t("view-users.create-cohort"),
    icon: "community",
    theme: ButtonTheme.Tertiary,
    layout: ButtonLayout.Vertical,
    "show-upsell-in-dropdown": true
  }, props: {
    cohortDetails: this.state.cohortDetails
  }, on: {
    create: this.handleCohortEvent(TrackingEvent.CreateCohort),
    save: this.handleCohortEvent(TrackingEvent.SaveCohort)
  } }))), /* @__PURE__ */ jsx("div", { sel: ".search" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    icon: "search",
    placeholder: t("view-users.search-placeholder"),
    "show-clear": true,
    "auto-focus": true
  }, style: {
    width: "100%"
  }, on: {
    input: this.handleSearch,
    clear: this.handleSearch
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".content" }, error && /* @__PURE__ */ jsx(ServerErrorHero, { reportName: WarningHeroReportName.Users }), (loading || !error) && /* @__PURE__ */ jsx(UsersTableEl, { attrs: {
    "data-group-id": cohort.dataGroupId || "",
    loading,
    "is-select-enabled": false,
    "showing-properties": this.getShowingProperties(),
    "sensitive-properties": [],
    "default-sort-field": {
      value: "$last_seen"
    },
    "default-sort-order": -1,
    "emit-row-click": true,
    compact: true
  }, props: {
    rows: users.map((user) => _objectSpread({
      $distinct_id: user.$distinct_id
    }, user.$properties))
  }, on: {
    userSelected: this.handleUserSelected
  } })));
}
